/** Holds the wall whose length is currently being typed in. */
import create from 'zustand'
import { Wall } from '../editor/editor/objects/Walls/Wall';

export interface WallLengthStore {
    wall: Wall | null,
    open: (wall: Wall) => void,
    close: () => void
}

export const useWallLengthStore = create<WallLengthStore>(set => ({
    wall: null,
    open: (wall: Wall) => set(() => ({ wall })),
    close: () => set(() => ({ wall: null })),
}))
